import { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles/radio.module.css";

export const Radio = forwardRef((props, ref) => {
  const { onChange, id, value, labelText, checked, name, onMouseEnter, onMouseLeave } = props;

  const radioFillStyles = {
    order: `${props.isDisabled ? 0 : -1}`,
    WebkitOrder: `${props.isDisabled ? 0 : -1}`,
    backgroundColor: `${props.colour ? props.colour : "#f6f6f6"}`,
    backgroundImage: 'url("' + props.fill + '")',
  };

  const radioSquareStyles = {
    opacity: `${props.isDisabled ? "0.24" : "1"}`,
  };

  return (
    <label className={styles.container}>
      <input
        className={styles.hidden}
        type="radio"
        onChange={onChange}
        id={id + name}
        name={name}
        value={value}
        checked={checked}
        aria-checked={checked}
        ref={ref}
        // disabled={props.isDisabled}
      />
      {props.fill ? (
        <div
          className={`
            ${styles.radio}
            ${styles.swatch}
          `}
          id={id}
          data-label={labelText}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={radioFillStyles}
        />
      ) : (
        <div
          className={`
            ${styles.radio}
            ${styles.square}
          `}
          id={id}
          data-label={labelText}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          style={radioSquareStyles}
        >
          {labelText}
        </div>
      )}
    </label>
  );
});

Radio.propTypes = {
  fill: PropTypes.string,
  colour: PropTypes.string,
  /** Disable input */
  isDisabled: PropTypes.bool,
  /** true if the button is checked/selected */
  checked: PropTypes.bool,
  /** value for form input */
  value: PropTypes.string.isRequired,
  /** name for form input */
  name: PropTypes.string,
  /** id for form input */
  id: PropTypes.string.isRequired,
  /** label text */
  labelText: PropTypes.string,

  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onChange: PropTypes.func,
};
